import { StyleSheet } from 'react-native';

import { C } from '../../common';
import { ENV, LAYOUT, THEME } from '../../reactor/common';

const { PAGE_HEADER_HEIGHT } = C;
const { IS_WEB } = ENV;
const {
  COLOR, FONT, OFFSET, UNIT,
} = THEME;

export default StyleSheet.create({
  buttonShare: {
    marginRight: OFFSET + UNIT,
  },

  container: StyleSheet.flatten([
    LAYOUT.STYLE.ROW,
    {
      paddingHorizontal: OFFSET,
      position: IS_WEB ? 'fixed' : 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: PAGE_HEADER_HEIGHT,
      zIndex: 1,
    },
  ]),

  containerReading: StyleSheet.flatten([
    LAYOUT.STYLE.ROW,
    {
      flex: 1,
      justifyContent: 'flex-end',
      marginRight: OFFSET,
    },
  ]),

  containerShare: {
    alignItems: 'flex-end',
    top: 0,
    left: 0,
    right: -UNIT,
    bottom: 0,
    paddingTop: OFFSET,
    zIndex: 2,
    position: IS_WEB ? 'fixed' : 'absolute',
  },

  labelReading: {
    color: COLOR.WHITE,
    fontStyle: 'italic',
    marginLeft: UNIT / 2,
  },

  iconStories: {
    height: UNIT * 2.8,
    width: UNIT * 2.8,
  },

  touchable: {
    marginRight: UNIT,
  },

  scroll: {
    backgroundColor: 'rgba(0,0,0,0.33)',
  },

  stories: LAYOUT.STYLE.ROW,

  storiesCaption: {
    marginHorizontal: UNIT,
  },

  navigation: {
    width: OFFSET,
    height: OFFSET,
    backgroundColor: COLOR.TEXT,
  },

  progressBar: StyleSheet.flatten([
    LAYOUT.STYLE.ROW,
    {
      position: 'absolute',
      bottom: UNIT / 2,
      left: OFFSET,
      right: OFFSET,
      height: UNIT / 2,
      justifyContent: 'space-between',
    },
  ]),

  slide: {
    flex: 1,
    marginHorizontal: UNIT / 4,
    height: '100%',
    backgroundColor: 'rgba(255,255,255,0.2)',
    borderRadius: UNIT / 4,
  },

  slideActive: {
    backgroundColor: 'rgba(255,255,255,0.8)',
  },

  title: {
    color: COLOR.WHITE,
    fontWeight: FONT.WEIGHT.BOLD,
    marginHorizontal: UNIT,
  },
});
